import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()({
    getMobileLink: {
        textDecoration: "underline",
        cursor: "pointer",
    },
});
